import { atom } from "recoil";

export const isOrderSheetPageCurrencyKrw = atom<boolean>({
  key: "orderSheetPageStore",
  default: false,
});

export const orderSheetPageSearchKeywordStore = atom<string>({
  key: "orderSheetPageSearchKeywordStore",
  default: "",
});
